import React from "react";
import FacebookModal from "./FacebookModal";
import { getFacebookFeedUrl } from "../../../functions";

class News extends React.Component {
  constructor(props) {
    super(props);
    this.messageLength = 125;
    this.state = {
      cards: [{}, {}, {}]
    };
  }

  componentDidMount() {
    fetch(getFacebookFeedUrl(),{
      cache: "no-cache"
    })
      .then(response => response.json())
      .then(data => {
        data = data.data.filter(function(value, index, arr) {
          return value.message != null;
        });
        data = data.filter(function(value, index, arr) {
          return value.full_picture != null;
        });

        this.setState({
          cards: [
            {
              description:
                data[0].message.substring(0, this.messageLength) + "...",
              descriptionFull: data[0].message,
              URL: data[0].permalink_url,
              imageURL: data[0].full_picture,
              imageAlt: data[0].message,
              date: this.dateFormatter(data[0].created_time),
              profilePhoto:
                "https://graph.facebook.com/654367144697173/picture?type=small",
              cardType: "social"
            },
            {
              description:
                data[1].message.substring(0, this.messageLength) + "...",
              descriptionFull: data[1].message,
              URL: data[1].permalink_url,
              imageURL: data[1].full_picture,
              imageAlt: data[1].message,
              date: this.dateFormatter(data[1].created_time),
              profilePhoto:
                "https://graph.facebook.com/654367144697173/picture?type=small",
              cardType: "social"
            },
            {
              description:
                data[2].message.substring(0, this.messageLength) + "...",
              descriptionFull: data[2].message,
              URL: data[2].permalink_url,
              imageURL: data[2].full_picture,
              imageAlt: data[2].message,
              date: this.dateFormatter(data[2].created_time),
              profilePhoto:
                "https://graph.facebook.com/654367144697173/picture?type=small",
              cardType: "social"
            },
            {
              description:
                data[3].message.substring(0, this.messageLength) + "...",
              descriptionFull: data[3].message,
              URL: data[3].permalink_url,
              imageURL: data[3].full_picture,
              imageAlt: data[3].message,
              date: this.dateFormatter(data[3].created_time),
              profilePhoto:
                "https://graph.facebook.com/654367144697173/picture?type=small",
              cardType: "social"
            }
          ]
        });

        this.equalCardHeight();
      });
  }

  equalCardHeight() {
    function newsEventsHeight() {
      var newsEventsItems = document.querySelectorAll("#news .single-card");
      var tallest = 0;

      if (matchMedia("(min-width: 768px)").matches) {
        for (var i = 0; i < newsEventsItems.length; i++) {
          newsEventsItems[i].style.height = "auto";
        }

        for (var i = 0; i < newsEventsItems.length; i++) {
          if (newsEventsItems[i].clientHeight > tallest) {
            tallest = newsEventsItems[i].clientHeight;
          }
        }
        for (var i = 0; i < newsEventsItems.length; i++) {
          newsEventsItems[i].style.height = tallest + "px";
        }
      } else {
        for (var i = 0; i < newsEventsItems.length; i++) {
          newsEventsItems[i].style.height = "auto";
        }
      }
    }
    newsEventsHeight();
    window.onresize = newsEventsHeight;
  }

  dateFormatter(unformattedDate) {
    const date = new Date(unformattedDate);

    var months = new Array();
    months[0] = "January";
    months[1] = "February";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "July";
    months[7] = "August";
    months[8] = "September";
    months[9] = "October";
    months[10] = "November";
    months[11] = "December";
    var month = months[date.getMonth()];
    var day = date.getDate();
    var hour = date.getHours();
    var minutes = date.getMinutes();

    if (hour.toString().length == "1") {
      var leadingZeroHour = "0";
    } else {
      var leadingZeroHour = "";
    }

    if (minutes.toString().length == "1") {
      var leadingZeroMinute = "0";
    } else {
      var leadingZeroMinute = "";
    }

    return (
      day + " " + month
    ); /* + " at " + leadingZeroHour + hour + ":" + leadingZeroMinute + minutes */
  }

  render() {
    console.log(this.state.cards[3])
    if(this.state.cards[3]){
      return (
        <div id="news">
          <h2>News</h2>
          <div className="view-all-news-link">
            <span className="heading-divider"></span>
            <a href="https://www.facebook.com/agriculturevictoria/">
              Visit Agriculture Victoria on Facebook
              <span className="arrow-right"></span>
            </a>
          </div>
          <div className="container-fluid">
            <div className="row">
              {this.state.cards.map((item, index) => (
                <div
                  className="col-12  col-md-6 col-lg-6  col-xl-3 d-flex align-items-stretch"
                  key={"single-card-" + index}
                >
                  <FacebookModal data={this.state.cards[index]} />
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }else{
            return (<div></div>)
    }
  }
}

export default News;
